module.exports = __webpack_public_path__ + "img/ranking_top1_big.9772b4ad.webp";